import {ControlsHeightContext} from '@jetbrains/ring-ui-built/components/global/controls-height'
import {use} from 'react'

export function useControlsHeight() {
  const contextValue = use(ControlsHeightContext)
  return typeof contextValue === 'function' ? contextValue() : contextValue
}
